export const AUTH_TOKEN_KEY = "token";
export const AUTH_USER_KEY = "user";
export const AUTH_SCOPE_KEY = "authScope";
export const AUTH_ROLE_KEY = "authRole";

export const getAuthState = () => ({
  token: localStorage.getItem(AUTH_TOKEN_KEY),
  user: localStorage.getItem(AUTH_USER_KEY),
  scope: localStorage.getItem(AUTH_SCOPE_KEY) || "admin",
  role: localStorage.getItem(AUTH_ROLE_KEY) || "",
});

export const setAuthSession = ({ token, user, scope, role }) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, user);
  localStorage.setItem(AUTH_SCOPE_KEY, scope || "admin");
  localStorage.setItem(AUTH_ROLE_KEY, role || "");
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_SCOPE_KEY);
  localStorage.removeItem(AUTH_ROLE_KEY);
};

export const getDefaultRouteForScope = (scope) => (scope === "hr" ? "/pay-slip" : "/quote-form");

export const isRouteAllowed = (route, scope) => {
  if (!route?.allowedScopes || route.allowedScopes.length === 0) return true;
  return route.allowedScopes.includes(scope);
};

export const filterRoutesByScope = (routes, scope) => routes.filter((route) => isRouteAllowed(route, scope));
